import { isArray } from "lodash";
import { useContext } from "react";

import { DropdownSourceContext } from "@ryde/redux";
import { NO_VALUE_DISPLAY, onlyNumericArrayValues } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvTagsCellTransformer = (): {
  getTagsListValue: CsvCellTransformerFn;
} => {
  const { getDropdownLabels } = useContext(DropdownSourceContext);

  const fetchTagsTitle = async (tagIds: number[]): Promise<string> => {
    const tagsNormalizedIds = onlyNumericArrayValues(tagIds);

    if (tagsNormalizedIds?.length) {
      const tagsLabelsFetched = await getDropdownLabels(
        "systemTag",
        tagsNormalizedIds,
      );

      if (tagsLabelsFetched?.length) {
        return tagsLabelsFetched.join(", ");
      }
    }

    return NO_VALUE_DISPLAY;
  };

  const getTagsListValue = async ({
    value,
  }: ICsvColumnTransformer): Promise<string> => {
    if (value && typeof value === "string") {
      return value;
    }

    if (isArray(value)) {
      return fetchTagsTitle(value);
    }

    return NO_VALUE_DISPLAY;
  };

  return { getTagsListValue };
};
